"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: offer/offer-content.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Foffer%2Foffer-content.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.offerLabelTypeToJSON = exports.offerLabelTypeFromJSON = exports.OfferRewardContentAvailability = exports.OfferRewardContentCode = exports.OfferRewardContentMultiplier = exports.OfferRewardContentPercent = exports.OfferRewardContent = exports.OfferDetailsContent = exports.OfferActivityContent = exports.OfferCellContent = exports.OfferContent = exports.OfferLabelType = void 0;
const amount_1 = require("../common/amount");
const image_1 = require("../common/image");
const protobufPackage = 'com.step.offer.proto';
/**
 * Offer label type.
 */
var OfferLabelType;
(function (OfferLabelType) {
    OfferLabelType["INVALID_OFFER_LABEL"] = "INVALID_OFFER_LABEL";
    /**
     * NEW - To be shown one week since the launch of the perk
     */
    OfferLabelType["NEW"] = "NEW";
    /**
     * EXPIRING_SOON - Shown for a week leading up to the Perk expiry
     */
    OfferLabelType["EXPIRING_SOON"] = "EXPIRING_SOON";
    OfferLabelType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(OfferLabelType || (exports.OfferLabelType = OfferLabelType = {}));
function createBaseOfferContent() {
    return {
        cell: exports.OfferCellContent.fromPartial({}),
        details: exports.OfferDetailsContent.fromPartial({}),
        activity: undefined,
        rewards: [],
        label: OfferLabelType.INVALID_OFFER_LABEL,
        isFeatured: false,
    };
}
exports.OfferContent = {
    fromJSON(object) {
        const message = {
            cell: isSet(object.cell)
                ? exports.OfferCellContent.fromJSON(object.cell)
                : exports.OfferCellContent.fromPartial({}),
            details: isSet(object.details)
                ? exports.OfferDetailsContent.fromJSON(object.details)
                : exports.OfferDetailsContent.fromPartial({}),
            rewards: globalThis.Array.isArray(object?.rewards)
                ? object.rewards.map((e) => exports.OfferRewardContent.fromJSON(e))
                : [],
            isFeatured: isSet(object.isFeatured) ? globalThis.Boolean(object.isFeatured) : false,
        };
        if (isSet(object.activity)) {
            message.activity = exports.OfferActivityContent.fromJSON(object.activity);
        }
        if (isSet(object.label)) {
            message.label = offerLabelTypeFromJSON(object.label);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cell !== undefined) {
            obj.cell = exports.OfferCellContent.toJSON(message.cell);
        }
        if (message.details !== undefined) {
            obj.details = exports.OfferDetailsContent.toJSON(message.details);
        }
        if (message.activity !== undefined) {
            obj.activity = exports.OfferActivityContent.toJSON(message.activity);
        }
        if (message.rewards?.length) {
            obj.rewards = message.rewards.map((e) => exports.OfferRewardContent.toJSON(e));
        }
        if (message.label !== undefined && message.label !== OfferLabelType.INVALID_OFFER_LABEL) {
            obj.label = offerLabelTypeToJSON(message.label);
        }
        if (message.isFeatured !== false) {
            obj.isFeatured = message.isFeatured;
        }
        return obj;
    },
    create(base) {
        return exports.OfferContent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOfferContent();
        message.cell = (object.cell !== undefined && object.cell !== null)
            ? exports.OfferCellContent.fromPartial(object.cell)
            : exports.OfferCellContent.fromPartial({});
        message.details = (object.details !== undefined && object.details !== null)
            ? exports.OfferDetailsContent.fromPartial(object.details)
            : exports.OfferDetailsContent.fromPartial({});
        message.activity = (object.activity !== undefined && object.activity !== null)
            ? exports.OfferActivityContent.fromPartial(object.activity)
            : undefined;
        message.rewards = object.rewards?.map((e) => exports.OfferRewardContent.fromPartial(e)) || [];
        message.label = object.label ?? OfferLabelType.INVALID_OFFER_LABEL;
        message.isFeatured = object.isFeatured ?? false;
        return message;
    },
};
function createBaseOfferCellContent() {
    return { image: undefined, text: '', images: [] };
}
exports.OfferCellContent = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.image)) {
            message.image = image_1.Image.fromJSON(object.image);
        }
        if (isSet(object.text)) {
            message.text = globalThis.String(object.text);
        }
        if (globalThis.Array.isArray(object?.images)) {
            message.images = object.images.map((e) => image_1.Image.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.image !== undefined) {
            obj.image = image_1.Image.toJSON(message.image);
        }
        if (message.text !== undefined && message.text !== '') {
            obj.text = message.text;
        }
        if (message.images?.length) {
            obj.images = message.images.map((e) => image_1.Image.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.OfferCellContent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOfferCellContent();
        message.image = (object.image !== undefined && object.image !== null)
            ? image_1.Image.fromPartial(object.image)
            : undefined;
        message.text = object.text ?? '';
        message.images = object.images?.map((e) => image_1.Image.fromPartial(e)) || [];
        return message;
    },
};
function createBaseOfferActivityContent() {
    return { description: '', subtitle: '', title: '' };
}
exports.OfferActivityContent = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        if (isSet(object.subtitle)) {
            message.subtitle = globalThis.String(object.subtitle);
        }
        if (isSet(object.title)) {
            message.title = globalThis.String(object.title);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        if (message.subtitle !== undefined && message.subtitle !== '') {
            obj.subtitle = message.subtitle;
        }
        if (message.title !== undefined && message.title !== '') {
            obj.title = message.title;
        }
        return obj;
    },
    create(base) {
        return exports.OfferActivityContent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOfferActivityContent();
        message.description = object.description ?? '';
        message.subtitle = object.subtitle ?? '';
        message.title = object.title ?? '';
        return message;
    },
};
function createBaseOfferDetailsContent() {
    return {
        header: undefined,
        color: '',
        body: '',
        headerImages: [],
        backgroundImage: undefined,
        terms: '',
        statusDescription: '',
    };
}
exports.OfferDetailsContent = {
    fromJSON(object) {
        const message = {
            color: isSet(object.color) ? globalThis.String(object.color) : '',
            body: isSet(object.body) ? globalThis.String(object.body) : '',
        };
        if (isSet(object.header)) {
            message.header = image_1.Image.fromJSON(object.header);
        }
        if (globalThis.Array.isArray(object?.headerImages)) {
            message.headerImages = object.headerImages.map((e) => image_1.Image.fromJSON(e));
        }
        if (isSet(object.backgroundImage)) {
            message.backgroundImage = image_1.Image.fromJSON(object.backgroundImage);
        }
        if (isSet(object.terms)) {
            message.terms = globalThis.String(object.terms);
        }
        if (isSet(object.statusDescription)) {
            message.statusDescription = globalThis.String(object.statusDescription);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.header !== undefined) {
            obj.header = image_1.Image.toJSON(message.header);
        }
        if (message.color !== '') {
            obj.color = message.color;
        }
        if (message.body !== '') {
            obj.body = message.body;
        }
        if (message.headerImages?.length) {
            obj.headerImages = message.headerImages.map((e) => image_1.Image.toJSON(e));
        }
        if (message.backgroundImage !== undefined) {
            obj.backgroundImage = image_1.Image.toJSON(message.backgroundImage);
        }
        if (message.terms !== undefined && message.terms !== '') {
            obj.terms = message.terms;
        }
        if (message.statusDescription !== undefined && message.statusDescription !== '') {
            obj.statusDescription = message.statusDescription;
        }
        return obj;
    },
    create(base) {
        return exports.OfferDetailsContent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOfferDetailsContent();
        message.header = (object.header !== undefined && object.header !== null)
            ? image_1.Image.fromPartial(object.header)
            : undefined;
        message.color = object.color ?? '';
        message.body = object.body ?? '';
        message.headerImages = object.headerImages?.map((e) => image_1.Image.fromPartial(e)) || [];
        message.backgroundImage =
            (object.backgroundImage !== undefined && object.backgroundImage !== null)
                ? image_1.Image.fromPartial(object.backgroundImage)
                : undefined;
        message.terms = object.terms ?? '';
        message.statusDescription = object.statusDescription ?? '';
        return message;
    },
};
function createBaseOfferRewardContent() {
    return {
        amount: undefined,
        multiplier: undefined,
        benefit: undefined,
        percent: undefined,
        code: undefined,
        availability: undefined,
        auxiliaryTitle: '',
    };
}
exports.OfferRewardContent = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        if (isSet(object.multiplier)) {
            message.multiplier = exports.OfferRewardContentMultiplier.fromJSON(object.multiplier);
        }
        if (isSet(object.benefit)) {
            message.benefit = exports.OfferRewardContentMultiplier.fromJSON(object.benefit);
        }
        if (isSet(object.percent)) {
            message.percent = exports.OfferRewardContentPercent.fromJSON(object.percent);
        }
        if (isSet(object.code)) {
            message.code = exports.OfferRewardContentCode.fromJSON(object.code);
        }
        if (isSet(object.availability)) {
            message.availability = exports.OfferRewardContentAvailability.fromJSON(object.availability);
        }
        if (isSet(object.auxiliaryTitle)) {
            message.auxiliaryTitle = globalThis.String(object.auxiliaryTitle);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.multiplier !== undefined) {
            obj.multiplier = exports.OfferRewardContentMultiplier.toJSON(message.multiplier);
        }
        if (message.benefit !== undefined) {
            obj.benefit = exports.OfferRewardContentMultiplier.toJSON(message.benefit);
        }
        if (message.percent !== undefined) {
            obj.percent = exports.OfferRewardContentPercent.toJSON(message.percent);
        }
        if (message.code !== undefined) {
            obj.code = exports.OfferRewardContentCode.toJSON(message.code);
        }
        if (message.availability !== undefined) {
            obj.availability = exports.OfferRewardContentAvailability.toJSON(message.availability);
        }
        if (message.auxiliaryTitle !== undefined && message.auxiliaryTitle !== '') {
            obj.auxiliaryTitle = message.auxiliaryTitle;
        }
        return obj;
    },
    create(base) {
        return exports.OfferRewardContent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOfferRewardContent();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        message.multiplier = (object.multiplier !== undefined && object.multiplier !== null)
            ? exports.OfferRewardContentMultiplier.fromPartial(object.multiplier)
            : undefined;
        message.benefit = (object.benefit !== undefined && object.benefit !== null)
            ? exports.OfferRewardContentMultiplier.fromPartial(object.benefit)
            : undefined;
        message.percent = (object.percent !== undefined && object.percent !== null)
            ? exports.OfferRewardContentPercent.fromPartial(object.percent)
            : undefined;
        message.code = (object.code !== undefined && object.code !== null)
            ? exports.OfferRewardContentCode.fromPartial(object.code)
            : undefined;
        message.availability = (object.availability !== undefined && object.availability !== null)
            ? exports.OfferRewardContentAvailability.fromPartial(object.availability)
            : undefined;
        message.auxiliaryTitle = object.auxiliaryTitle ?? '';
        return message;
    },
};
function createBaseOfferRewardContentPercent() {
    return { value: '', currency: '' };
}
exports.OfferRewardContentPercent = {
    fromJSON(object) {
        const message = {
            value: isSet(object.value) ? globalThis.String(object.value) : '',
            currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.value !== '') {
            obj.value = message.value;
        }
        if (message.currency !== '') {
            obj.currency = message.currency;
        }
        return obj;
    },
    create(base) {
        return exports.OfferRewardContentPercent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOfferRewardContentPercent();
        message.value = object.value ?? '';
        message.currency = object.currency ?? '';
        return message;
    },
};
function createBaseOfferRewardContentMultiplier() {
    return { value: '', label: '' };
}
exports.OfferRewardContentMultiplier = {
    fromJSON(object) {
        const message = {
            value: isSet(object.value) ? globalThis.String(object.value) : '',
            label: isSet(object.label) ? globalThis.String(object.label) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.value !== '') {
            obj.value = message.value;
        }
        if (message.label !== '') {
            obj.label = message.label;
        }
        return obj;
    },
    create(base) {
        return exports.OfferRewardContentMultiplier.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOfferRewardContentMultiplier();
        message.value = object.value ?? '';
        message.label = object.label ?? '';
        return message;
    },
};
function createBaseOfferRewardContentCode() {
    return { value: '' };
}
exports.OfferRewardContentCode = {
    fromJSON(object) {
        const message = {
            value: isSet(object.value) ? globalThis.String(object.value) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.value !== '') {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.OfferRewardContentCode.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOfferRewardContentCode();
        message.value = object.value ?? '';
        return message;
    },
};
function createBaseOfferRewardContentAvailability() {
    return { online: false, inStore: false };
}
exports.OfferRewardContentAvailability = {
    fromJSON(object) {
        const message = {
            online: isSet(object.online) ? globalThis.Boolean(object.online) : false,
            inStore: isSet(object.inStore) ? globalThis.Boolean(object.inStore) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.online !== false) {
            obj.online = message.online;
        }
        if (message.inStore !== false) {
            obj.inStore = message.inStore;
        }
        return obj;
    },
    create(base) {
        return exports.OfferRewardContentAvailability.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOfferRewardContentAvailability();
        message.online = object.online ?? false;
        message.inStore = object.inStore ?? false;
        return message;
    },
};
function offerLabelTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_OFFER_LABEL':
            return OfferLabelType.INVALID_OFFER_LABEL;
        case 1:
        case 'NEW':
            return OfferLabelType.NEW;
        case 2:
        case 'EXPIRING_SOON':
            return OfferLabelType.EXPIRING_SOON;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return OfferLabelType.UNRECOGNIZED;
    }
}
exports.offerLabelTypeFromJSON = offerLabelTypeFromJSON;
function offerLabelTypeToJSON(object) {
    switch (object) {
        case OfferLabelType.INVALID_OFFER_LABEL:
            return 'INVALID_OFFER_LABEL';
        case OfferLabelType.NEW:
            return 'NEW';
        case OfferLabelType.EXPIRING_SOON:
            return 'EXPIRING_SOON';
        case OfferLabelType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.offerLabelTypeToJSON = offerLabelTypeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=offer-content.js.map